import { render, staticRenderFns } from "./passenger-icon.vue?vue&type=template&id=75c45c14"
import script from "./passenger-icon.vue?vue&type=script&lang=js"
export * from "./passenger-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports